import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";

import { FaArtstation } from "react-icons/fa";

import "./Icons.css";

export default function Icons() {
  return (
    <div className="icons">
      <nav className="linkedin">
        <a
          href="https://www.linkedin.com/in/felixeugene/"
          target="_blank"
          title="LinkedIn Profile"
          rel="noreferrer"
        >
          <FaLinkedin />
        </a>
      </nav>
      <nav className="mail">
        <a href="mailto:felix.martono@gmail.com" title="email Address">
          <MdOutlineMail />
        </a>
      </nav>

      <nav className="artstation">
        <a
          href="https://www.artstation.com/felixeugene"
          target="_blank"
          title="Art Station Profile"
          rel="noreferrer"
        >
          <FaArtstation />
        </a>
      </nav>
    </div>
  );
}
